import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  DialogActions,
} from "@mui/material";
import FormTextField from "../ui/FormTextField";
import { PrimaryButton } from "../ui/PrimaryButton";
import { SecondaryButton } from "../ui/SecondaryButton";

function InfoDescriptionForm({ onClose }) {
  const [info, setInfo] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = () => {
    console.log("Submitted:", { info, description });
    onClose();
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Додавання інформації
      </Typography>
      <FormTextField
        label="Характиристика"
        value={info}
        onChange={(e) => setInfo(e.target.value)}
      />

      <FormTextField
        label="Опис"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />

      <DialogActions sx={{ p: 0, justifyContent: "start" }}>
        <PrimaryButton onClick={handleSubmit}>Зберегти</PrimaryButton>
        <SecondaryButton onClick={onClose}>Закрити</SecondaryButton>
      </DialogActions>
    </Box>
  );
}

export default InfoDescriptionForm;
